import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class WindowReferenceService {

  getWindow():any {
    return window;
  }

  get nativeWindow() {
    return this.getWindow();
  }
}
